import {
  useCommentSdk,
  getAdShield,
  getCommentAdPosition,
  getCommentMoreUrl,
  getReplyPageUrl,
  getCommentStatus,
  isShowFold,
} from './store_assist';

import {
  getTopicId,
  getEnv,
  getDocId,
  brandName,
  getCommentEnv,
  getSourceEn,
} from '@js/utils-feeds';
import { query, getQuery } from '@js/utils';

const lscache = require('ls-cache');

const cache = lscache.createBucket(`${brandName}news-feeds-${getDocId()}`);

function initData() {
  const docInfo = window.pageData.DOCINFO || {};
  let keywords = [];
  if (docInfo.keywords && typeof docInfo.keywords === 'string') {
    keywords = docInfo.keywords.split(',');
  } else {
    keywords = docInfo.keywords;
  }
  const source = (
    docInfo.sourceEn ||
    docInfo.source ||
    query.get('sourceMedia') ||
    ''
  ).toLowerCase();
  const sourceVal = source == 'tencent' ? 'tencent' : 'oppo';

  const commentStatus = getCommentStatus();
  return {
    docInfo,
    pics: docInfo.contentPicList || [],
    env: getEnv(),
    commentEnv: getCommentEnv(), // 评论SDK的环境变量，使用云平台的COMMENT_ENV
    docId: getDocId(),
    topicId: getTopicId(),
    resourceId: docInfo.resourceId || '',
    styleType: docInfo.__styleType__ || query.get('__styleType__'),
    quickGameResourceId: query.get('__quickGameResourceId__'), // 用于判断媒体号是否显示

    title: docInfo.title || document.title,
    description: docInfo.description,
    url: docInfo.url || docInfo.sourceUrl || location.href,

    keywords: keywords,
    publishTime: docInfo.publishTime || '',

    pageType: docInfo.pageType || window.pageType || 'document',
    cardContent: {
      cardisSubscribe: true,
      node: '',
      event: '',
      isCard: false,
    },
    cardList: [],
    source: source,
    sourceVal: sourceVal,
    sourceName: docInfo.sourceName,
    sourceCode: docInfo.sourceCode,
    sourceEn: getSourceEn(docInfo),
    vendor: docInfo.vendor,
    uuid: window.wv.getUuid(),
    loginSession: window.wv.getIflowSession(),
    loginUid: window.wv.getUid(),
    fromId: getQuery('__fromId__'),
    commentStatus,
    gallerys: docInfo.gallerys || [],
    isThumbUp: cache.get('isThumbUp') || false,
    upsCount: Math.max(cache.get('praise') || 0, docInfo.upsCount || 0),
    replyPageUrl: getReplyPageUrl(commentStatus),

    commentMoreUrl: getCommentMoreUrl(commentStatus),
    useCommentSdk: useCommentSdk(), // 是否使用评论SDK
    commentAdPosition: getCommentAdPosition(),
    activity_id: query.get('activity_id'),
    bs_entry: query.get('bs_entry'),
    noAd: query.get('noAd'), // 广告开关
    adShield: getAdShield(),
    isShowFold: isShowFold() || false,
    media: docInfo.media || {}, // 媒体号相关信息
    videoInfo: docInfo.videoInfo ? docInfo.videoInfo : docInfo, //视频相关信息
    coverUrl: docInfo.coverUrl || '',
    commentCount:
      query.get('__comment__') === '0_0' ? 0 : docInfo?.count?.comment || 0,
    pageMode:
      window.BrowserNormal &&
      window.BrowserNormal.isMiniApp &&
      window.BrowserNormal.isMiniApp()
        ? 'simple'
        : 'other', // 页面是否处于极简模式
  };
}

class Store {
  constructor() {
    this.data = initData();
  }
  get(key) {
    return this.data[key];
  }
  set(key, value) {
    this.data[key] = value;
  }

  // 是否暗色模式
  get nightMode() {
    if (window.wv && window.wv.isNightMode) {
      let isNightMode = window.wv.isNightMode();
      return isNightMode && isNightMode.code === 0 && isNightMode.data === true;
    }
    return false;
  }

  thumbUp() {
    const { data } = this;
    if (data.isThumbUp) {
      data.upsCount--;
    } else {
      data.upsCount++;
    }
    data.isThumbUp = !data.isThumbUp;
    cache.set('praise', data.upsCount); //点赞数不计入缓存，每次重新读取

    const key = 'isThumbUp';
    data.isThumbUp ? cache.set(key, data.isThumbUp) : cache.remove(key);
  }
}
let store;

export default function createStore() {
  if (!store) {
    store = new Store();
    store = new Proxy(store, {
      get(target, prop, receiver) {
        if (Object.prototype.hasOwnProperty.call(target, prop)) {
          return target[prop];
        } else if (Object.prototype.hasOwnProperty.call(target.data, prop)) {
          return target.get(prop);
        }
        return Reflect.get(...arguments);
      },
    });
  }
  return store;
}
